<template>
    <v-container class="align-start container--fluid">
        <v-tabs :value="active_tab" background-color="transparent" class="denser-tabs" slider-size="4">
            <v-tab v-for="tab in tabs" :key="tab.value" @click="onNavTabClick(tab.route)">
                <span class="caption font-weight-medium">
                    {{ tab.text }}
                </span>
            </v-tab>
        </v-tabs>
        <v-row no-gutters>
            <v-col class="mt-3">
                <router-view/>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
//import script
import {$t} from "../../i18n";
import {Router} from "../../composables/Router";
import {computed} from "@vue/composition-api";

export default {
    name: "Admin",
    setup(props, ctx) {
        const router = Router();
        const tabs = [
            {text: $t("Members"), value: "Users", route: {name: "abiline_u"}},
            {text: $t("Companies"), value: "Companies", route: {name: "abiline_c"}},
            {text: $t("Leads"), value: "Leads", route: {name: "abiline_l"}},
            {text: $t("Demos"), value: "Demos", route: {name: "abiline_d"}},
            {text: $t("Calendar"), value: "Calendar", route: {name: "abiline_k"}},
            {text: $t("Help"), value: "Help", route: {name: "abiline_h"}},
            {text: $t("Vouchers"), value: "Vouchers", route: {name: "abiline_v"}},
            {text: $t("KPI"), value: "KPI", route: {name: "abiline_kpi"}},
            {text: $t('Referrals'), value: "Referrals", route: {name: "abiline_r"}},
            {text: $t('Audit Log'), value: "AuditLog", route: {name: "abiline_al"}},
        ];
        const current_route = computed(() => ctx.root._route);
        const active_tab = computed(() => tabs.findIndex(tab => tab.route.name === current_route.value.name));
        const onNavTabClick = route => {
            router.push(route);
        };
        return {
            tabs,
            onNavTabClick,
            active_tab
        };
    }
};
</script>
